import { render } from "./Edit.vue?vue&type=template&id=fa6a4dca"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__